import React from "react";

const BranchClosed = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="18"
        y="5"
        width="1"
        height="13"
        transform="rotate(90 18 5)"
        fill="#023A4A"
      />
      <path d="M7 5.5C14.6927 5.5 7.35135 16.5 16 16.5" stroke="#023A4A" />
      <circle cx="17.5" cy="16.5" r="2" stroke="#023A4A" />
      <circle cx="19.5" cy="5.5" r="2" stroke="#023A4A" />
      <circle cx="3.5" cy="5.5" r="2" stroke="#023A4A" />
    </svg>
  );
};

export default BranchClosed;
